import { useGetAllFilterTags } from 'api/systems/systems.api'
import { useEffect } from 'react'
import authStore from 'store/auth/auth'
import { syncSystemTagsWithStore } from 'store/filter/filter'
import { useSnapshot } from 'valtio'

export default function SyncSystemTagsWithStore(): null {
  const { systemId } = useSnapshot(authStore)
  const { data: filterTagsForSystem } = useGetAllFilterTags(systemId)

  useEffect(() => {
    syncSystemTagsWithStore(filterTagsForSystem)
  }, [filterTagsForSystem])

  return null
}
